import { render } from "./Step.vue?vue&type=template&id=ba48a28c&scoped=true"
import script from "./Step.js?vue&type=script&lang=js&external"
export * from "./Step.js?vue&type=script&lang=js&external"

import "./Step.scss?vue&type=style&index=0&id=ba48a28c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba48a28c"]])

export default __exports__